export default {
    totalEmployees: 'Total Employees',
    mon: 'Mon',
    tues: 'Tue',
    wednes: 'Wed',
    thurs: 'Thu',
    fri: 'Fri',
    satur: 'Sat',
    sun: 'Sun',
    present: 'Present',
    late: 'Late'
}
